import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, shareReplay } from 'rxjs/operators';
import { DataCacheService } from "./services/caching/data-cache.service";

/*
Will intercept any http request and prevent it being made if the same url request is already in progress.
The currently in progress request will be returned instead.
*/

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    private requestsInProgress = new Map<string, Observable<HttpEvent<any>>>();

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.method !== 'GET') {
            return next.handle(request);
        }

        const url = request.urlWithParams;
        const existingRequest = this.requestsInProgress.get(url);

        if (request.params.get("minsToLive")) {
            console.warn("minsToLive does not work in Angular services", request.urlWithParams);
        }

        if (existingRequest) {
            console.warn(`Request to ${url} has been cancelled because it is already in progress.`);
            return existingRequest;
        }

        const newRequest = next.handle(request).pipe(
            shareReplay(1), // Cache the response for future subscribers
            finalize(() => {
                this.requestsInProgress.delete(url);
            })
        );

        this.requestsInProgress.set(url, newRequest);

        return newRequest;
    }
}
